module.exports = __webpack_public_path__ + "static/media/icon@2x.6ef960db.png";